import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent } from 'react';
import { type RegisterOptions } from 'react-hook-form';
import { Button } from '@shared/ui-components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { FileInput } from '@shared/ui-components/file-input/file-input';
import { ALLOWED_EXTENSIONS_INPUT_ACCEPT } from '@shared/utils/constants/fileUpload';
import { type ButtonType } from '@shared/utils/enums/button-type';
import styles from './upload-photo-dialog-actions.module.scss';
export type FileInputProps = {
  fileInputError: boolean;
  fileInputLabel?: string;
  fileInputName: string;
  fileInputRules: RegisterOptions;
  fileInputVariant?: ButtonVariant;
  onFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
};
export type UploadPhotoDialogActionsProps = FileInputProps & {
  onPrimaryButtonClick?: () => void;
  onTertiaryButtonClick?: () => void;
  primaryButtonDisabled?: boolean;
  primaryButtonLabel?: string;
  primaryButtonType?: ButtonType;
  tertiaryButtonLabel?: string;
};
export const UploadPhotoDialogActions = t0 => {
  const $ = _c(23);
  const {
    fileInputError,
    fileInputLabel,
    fileInputName,
    fileInputRules,
    fileInputVariant,
    onFileInputChange,
    onPrimaryButtonClick,
    onTertiaryButtonClick,
    primaryButtonDisabled,
    primaryButtonLabel,
    primaryButtonType,
    tertiaryButtonLabel
  } = t0;
  let t1;
  if ($[0] !== onTertiaryButtonClick || $[1] !== tertiaryButtonLabel) {
    t1 = onTertiaryButtonClick && tertiaryButtonLabel && <Button aria-label={tertiaryButtonLabel} dataTestId="dialog-delete-button" onClick={onTertiaryButtonClick} variant={ButtonVariant.Tertiary}>{tertiaryButtonLabel}</Button>;
    $[0] = onTertiaryButtonClick;
    $[1] = tertiaryButtonLabel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className={styles["upload-photo-dialog-actions__delete-button-container"]}>{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== fileInputError || $[6] !== fileInputLabel || $[7] !== fileInputName || $[8] !== fileInputRules || $[9] !== fileInputVariant || $[10] !== onFileInputChange) {
    t3 = fileInputLabel && <FileInput accept={ALLOWED_EXTENSIONS_INPUT_ACCEPT} ariaDescribedBy="profile-picture-requirements" ariaOwns="profile-photo-cropper" dataTestId={fileInputName} hasError={fileInputError} label={fileInputLabel} name={fileInputName} onChange={onFileInputChange} rules={fileInputRules} variant={fileInputVariant} />;
    $[5] = fileInputError;
    $[6] = fileInputLabel;
    $[7] = fileInputName;
    $[8] = fileInputRules;
    $[9] = fileInputVariant;
    $[10] = onFileInputChange;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== onPrimaryButtonClick || $[13] !== primaryButtonDisabled || $[14] !== primaryButtonLabel || $[15] !== primaryButtonType) {
    t4 = primaryButtonLabel && <Button aria-label={primaryButtonLabel} dataTestId="dialog-submit-button" disabled={primaryButtonDisabled} onClick={onPrimaryButtonClick && onPrimaryButtonClick} type={primaryButtonType}>{primaryButtonLabel}</Button>;
    $[12] = onPrimaryButtonClick;
    $[13] = primaryButtonDisabled;
    $[14] = primaryButtonLabel;
    $[15] = primaryButtonType;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <div className={styles["upload-photo-dialog-actions__button-group-container"]} data-testid="dialog-button-group">{t3}{t4}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t2 || $[21] !== t5) {
    t6 = <div className={styles["upload-photo-dialog-actions"]}>{t2}{t5}</div>;
    $[20] = t2;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};